<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 120.818 93.023"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <g id="Group_3434" data-name="Group 3434" transform="translate(-1239 -674)">
    <g id="Group_3425" data-name="Group 3425" transform="translate(1239.448 674.854)">
      <path :fill="iconColor" id="Path_4291" data-name="Path 4291" d="M398.64,302.208a32.343,32.343,0,0,0-64.5-3.452A25.569,25.569,0,0,0,305.861,339.4a3.444,3.444,0,0,0,5.22-4.495,18.676,18.676,0,0,1,24.513-27.724,3.443,3.443,0,0,0,5.346-3.112l-.013-.191c-.042-.584-.084-1.137-.084-1.669a25.455,25.455,0,1,1,50.708,3.05,3.444,3.444,0,0,0,3.731,3.839c.581-.053,1.06-.078,1.511-.078a16.366,16.366,0,0,1,11.572,27.938,3.443,3.443,0,1,0,4.869,4.869,23.254,23.254,0,0,0-14.6-39.623Z" transform="translate(-299.677 -269.868)"/>
      <path :fill="iconColor" id="Path_4292" data-name="Path 4292" d="M383.07,317.7a17.1,17.1,0,0,0-17.083,17.084,3.444,3.444,0,0,0,6.887,0,10.2,10.2,0,1,1,10.2,10.2,3.533,3.533,0,0,0-.484.036H319.449a3.444,3.444,0,0,0,0,6.887H383.07a3.436,3.436,0,0,0,.6-.052,17.081,17.081,0,0,0-.6-34.153Z" transform="translate(-296.217 -259.733)"/>
      <path :fill="iconColor" id="Path_4293" data-name="Path 4293" d="M346.356,340.579a17.082,17.082,0,1,0-17.68-17.068,3.444,3.444,0,1,0,6.887,0,10.2,10.2,0,1,1,10.2,10.2,3.365,3.365,0,0,0-.486.038H312.861a3.444,3.444,0,0,0,0,6.887h32.9A3.335,3.335,0,0,0,346.356,340.579Z" transform="translate(-297.613 -262.121)"/>
    </g>
  </g>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
